<template>
  <v-form @submit.prevent="handlerContinue">
    <v-row :class="!mdAndUp ? 'd-flex flex-column' : ''">
      <v-col md="3" sm="12">
        <v-card :class="['rounded-lg', mdAndUp && 'mr-3 mb-12']" elevation="0">
          <v-card-title>
            <v-icon class="mr-2">mdi-cloud-outline</v-icon>
            Adicionar Imagens
          </v-card-title>
          <v-card-subtitle class="ml-1">
            Adicione imagens para mostrar sobre o que será o seu combo.
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col md="9" sm="12">
        <v-card class="rounded-lg mb-12" elevation="0">
          <v-col md="8" sm="12" class="pt-0">
            <v-card-title class="text-h6">
              <v-icon class="mr-2"> mdi-image-multiple-outline </v-icon>
              Imagens</v-card-title
            >
            <v-card-subtitle class="ml-1">
              Adicione duas imagens (card e destaque).
            </v-card-subtitle>
            <v-card-text>
              <div
                class="image-uploader rounded-lg"
                @dragover.prevent
                @drop="handleDrop"
                @dragleave="enterHover = false"
                @dragover="enterHover = true"
                :class="{ 'drag-hover': enterHover }"
                @click="openFileInput"
                v-if="!imageLimit"
              >
                <div v-if="isUploading">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    indeterminate
                    color="primary"
                  >
                  </v-progress-circular>
                </div>
                <div v-else>
                  <input
                    type="file"
                    ref="fileInput"
                    style="display: none"
                    @change="handleFileInput"
                  />
                  <v-icon class="upload-icon"> mdi-cloud-upload </v-icon>
                  <div class="upload-text">
                    <p>Arraste e solte uma imagem aqui ou</p>
                    <p>Clique para fazer o upload</p>
                  </div>
                </div>
                <span class="image-quantity">
                  {{ imagePreview.length }}/2
                </span>
              </div>
              <v-progress-linear
                v-if="uploading"
                :value="getProgress"
                height="15"
                color="primary"
                :buffer-value="getProgress + 10"
                rounded
                >{{ getProgress }}%</v-progress-linear
              >
              <ul class="grey--text body-2 mt-2">
                <li>
                  Imagem Card:
                  <span class="font-weight-bold"> 1080x1920px</span>
                </li>
                <li>
                  Imagem Destaque:
                  <span class="font-weight-bold"> 600x300px</span>
                </li>
              </ul>
              <p class="grey--text body-2">
                Formato JPEG ou PNG de no máximo 2MB.
              </p>
              <v-col>
                <v-row>
                  <div
                    class="image-preview mt-5 rounded-lg mr-10"
                    v-for="(image, index) in imagePreview"
                    :key="index"
                  >
                    <v-img
                      :src="image.src"
                      max-height="100"
                      cover
                      class="rounded-t-lg rounded-b-lg"
                    />
                    <v-card-text class="text-center">{{
                      image.name
                    }}</v-card-text>
                    <v-btn
                      color="error red lighten-2"
                      fab
                      x-small
                      class="remove-img-btn rounded-pill"
                      @click="openConfirmModal(index)"
                    >
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                    <v-row justify="center" class="pb-3" v-if="imageLimit">
                      <v-chip-group
                        mandatory
                        active-class="primary--text"
                        v-model="image.type"
                        @change="handleChipChange(image, index)"
                      >
                        <v-chip small filter outlined value="imagem1"
                          >Card
                        </v-chip>
                        <v-chip small filter outlined value="destaque"
                          >Destaque
                        </v-chip>
                      </v-chip-group>
                    </v-row>
                  </div>
                </v-row>
              </v-col>
            </v-card-text>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-card-actions v-if="getComboType === 'new'">
      <v-spacer></v-spacer>
      <v-btn @click="backStep" text class="rounded-lg"> Voltar </v-btn>
      <v-btn color="primary" type="submit" class="rounded-lg"> Continue </v-btn>
    </v-card-actions>
    <confirm-modal
      v-model="deleteImage"
      @confirm="removeImage"
      @cancel="deleteImage = false"
      title="Confirmação"
      subtitle="Tem certeza de que deseja remover a imagem?"
    />
    <confirm-modal
      v-model="defaultImg"
      @confirm="saveDefaultImage"
      @cancel="defaultImg = false"
      :images="imagensDefault"
      title="Confirmação"
      subtitle="Tem certeza de que não deseja adicionar imagens?"
      message="Ao confirmar, o sistema irá adicionar imagens padrões para o seu combo."
    />
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";

export default {
  name: "imagesCombo",
  mixins: [displayHelpers],
  components: {
    confirmModal: () => import("@/components/global/newConfirmDialog.vue"),
  },
  data() {
    return {
      imagePreview: [],
      enterHover: false,
      deleteImage: false,
      defaultImg: false,
      indexToRemove: null,
      imagensDefault: [
        {
          src: "https://cloudfront.eleventickets.com/omni/dev/combo/0491138d3ac08166f902d58946888d5f4f364118_a44b335d6a",
          type: "imagem1",
          name: "default-card.png",
        },
        {
          src: "https://cloudfront.eleventickets.com/omni/dev/combo/625865cc9850bd2909f1540d894c2f1d616ca0ec_c073bda8bf",
          type: "destaque",
          name: "default-destaque.png",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getProgress",
      "comboModal",
      "isUploading",
      "getImages",
      "getComboType",
    ]),
    imageExists() {
      return this.imagePreview.length > 0;
    },
    imageLimit() {
      return this.imagePreview.length === 2;
    },
    uploading() {
      return this.getProgress > 0 && this.getProgress < 100;
    },
  },
  watch: {
    comboModal(val) {
      this.getInfos(val);
    },
  },
  methods: {
    ...mapActions([
      "saveImages",
      "backStep",
      "uploadImages",
      "showSnackbarSuccess",
    ]),
    getInfos(val) {
      if (val && this.getComboType === "new") {
        this.imagePreview = [];
      } else {
        this.imagePreview = this.getImages;
      }
    },
    openConfirmModal(index) {
      this.indexToRemove = index;
      this.deleteImage = true;
    },
    removeImage() {
      this.imagePreview.splice(this.indexToRemove, 1);
      this.showSnackbarSuccess("Imagem removida com sucesso!");
      this.deleteImage = false;
    },
    handlerContinue() {
      if (this.imagePreview.length < 2) {
        this.defaultImg = true;
        return false;
      }
      this.saveImages(this.imagePreview);
      return true;
    },
    saveDefaultImage() {
      this.saveImages(this.imagensDefault);
      this.imagePreview = this.imagensDefault;
      this.defaultImg = false;
    },
    handleChipChange(image, index) {
      const img = this.imagePreview[index];

      this.imagePreview.forEach(el => {
        if (el !== img) {
          image.type === "imagem1"
            ? (el.type = "destaque")
            : (el.type = "imagem1");
        }
      });
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileInput(event) {
      const file = event.target.files[0];
      this.uploadImage(file);
    },
    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      this.uploadImage(file);
    },
    async uploadImage(file) {
      this.enterHover = false;
      if (file) {
        try {
          const base64Image = await this.fileToBase64(file);
          const uploadImage = await this.uploadImages({
            img_base64: base64Image,
          });
          if (uploadImage) {
            this.imagePreview.push({
              src: uploadImage,
              type: "",
              name: file.name,
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
          resolve(event.target.result);
        };

        reader.onerror = error => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    },
  },
  mounted() {
    this.getInfos(this.comboModal);
  },
};
</script>
<style scoped lang="scss">
.image-uploader {
  position: relative;
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.upload-icon {
  font-size: 50px;
}

.upload-text {
  margin-top: 10px;
}

.drag-hover {
  border: 2px dashed var(--v-tertiary-base);
  background-color: var(--v-base-base);
  transition: all 0.2s ease-in-out;
}
.remove-img-btn {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
}
.image-preview {
  position: relative;
  border-radius: 50px;
  box-shadow: 11px 11px 22px #d9d9d9, -11px -11px 22px #ffffff;
  max-width: 200px;
  transition: all 0.2s ease-in-out;
}
.image-preview:hover {
  transform: scale(1.07);
}
.image-quantity {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  display: grid;
  place-items: center;
  background-color: var(--v-primary-base);
  color: #ffffff;
  padding: 0.25rem 0.55rem;
  border-radius: 0 12px 0 50px;
}
</style>
